import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { isNull } from 'lodash'

import {
  DialogLayout,
  CompanyTypeAndSeachInput,
  ConfirmationDialog,
} from 'components'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'
import schema from './schema'
import { useState } from 'react'

const OrganizationCompaniesForm = ({
  setOpen,
  open,
  refresh = () => {},
  organization,
  setIsLoading,
}) => {
  const [selectedCompany, setSelectedCompany] = useState({})
  const [oldResponsibleOrganization, setOldResponsibleOrganization] = useState()
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)

  const snackbar = useSnackbar()
  const { control, handleSubmit, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      company: null,
    },
  })

  const { GOVERNANCE_PROJECTS_ARCHIVE_WARNING } = constants.organizations

  const validateCompanyAlreadyLinked = async () => {
    const response = await service.backoffice.organizationCompanies.get({
      organizationId: organization?.id,
      companyId: selectedCompany,
      all: true,
    })

    const oldResponsibleOrganization =
      response?.data?.organizationCompanies.find(
        (organizationCompany) =>
          organizationCompany?.organization?.kind === organization?.kind,
      ) ?? null

    if (!isNull(oldResponsibleOrganization)) {
      setOpenConfirmationDialog(true)
      setOldResponsibleOrganization(oldResponsibleOrganization)
    } else {
      onSubmit(selectedCompany, false)
    }
  }

  const onSubmit = async (
    companyId,
    isChangeResponsibleOrganization,
    oldResponsibleOrganization = {},
  ) => {
    try {
      setIsLoading(true)
      if (isChangeResponsibleOrganization) {
        await service.backoffice.organizationCompanies.destroy({
          organizationId: oldResponsibleOrganization?.organization?.id,
          id: oldResponsibleOrganization?.id,
        })
      }

      await service.backoffice.organizationCompanies.create({
        id: organization?.id,
        companyId,
      })

      snackbar.open({
        message: 'Empresa vinculada ao Grupo Advisor.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setOpen(false)
      setOpenConfirmationDialog(false)
      setIsLoading(false)
      refresh()
    }
  }

  const confirmationText = `Você tem certeza que deseja alterar o Grupo Advisor
                            responsável pela empresa? Após confirmar, a empresa
                            passa a pertencer a esse Grupo Advisor.`

  return (
    <>
      <form>
        <DialogLayout
          title="Vincular Grupo Advisor ao usuário"
          open={open}
          setOpen={setOpen}
          confirmTextButton="Salvar"
          handleSubmit={handleSubmit(validateCompanyAlreadyLinked)}
        >
          <Box width={500}>
            <Box pb={2}>
              <CompanyTypeAndSeachInput
                control={control}
                errors={errors}
                fieldName="company"
                setCompanyId={setSelectedCompany}
              />
            </Box>
          </Box>
        </DialogLayout>
      </form>
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        message={confirmationText}
        alert={GOVERNANCE_PROJECTS_ARCHIVE_WARNING}
        alertColor="error"
        buttonText="Confirmar"
        actionAcceptButton={() =>
          onSubmit(selectedCompany, true, oldResponsibleOrganization)
        }
      />
    </>
  )
}

OrganizationCompaniesForm.propTypes = {
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  refresh: PropTypes.func,
  organization: PropTypes.object,
  setIsLoading: PropTypes.func,
}

export default OrganizationCompaniesForm
